// App version shown in the mobile top bar. The release scripts export
// REACT_APP_VERSION from android/app/build.gradle (versionName + versionCode)
// before building, so the APK always shows exactly what was shipped; a plain
// `npm run build` / `npm start` falls back to the constant below.
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.2';
